export default __webpack_public_path__ + "static/media/logo-dark.8a4943d7.png";